'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { Button } from '../button/button.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { Icon } from '../icon/icon.component.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)r = c[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)r = c[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ModalDialogCloseButton = renderWithRef('ModalDialogCloseButton', null, (o, a)=>{
    useDeprecatedProps('ModalDialogCloseButton', o, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: 'Use `accessibleText` instead'
        }
    ]);
    let { handleModalCloseButton: u } = useModalDialogContext(), { visuallyHiddenLabel: b, accessibleText: f, onClick: m, className: d, children: y } = o, O = _object_without_properties(o, [
        "visuallyHiddenLabel",
        "accessibleText",
        "onClick",
        "className",
        "children"
    ]), j = null != f ? f : b;
    return jsxs(Button, _object_spread_props(_object_spread({
        skin: "tertiary",
        buttonShape: "round",
        className: className('swan-modal-dialog-close-button', d),
        ref: a
    }, O), {
        onClick: composeEventHandlersUtil(m, u),
        children: [
            null !== j ? jsx(VisuallyHidden, {
                children: j
            }) : null,
            jsx(Icon, {
                iconType: "close",
                size: "standard"
            })
        ]
    }));
});

export { ModalDialogCloseButton };
